import React from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Form } from "antd";

function ContactInput({ form, name, label, require, placeholder, styles, disabled }) {
  return (
    <Form.Item
      name={name}
      rules={[
        {
          required: require,
          message: "Please enter phone number!",
        },
        {
          validator(_, value) {
            if (value && !isValidPhoneNumber(value)) {
              return Promise.reject(new Error("Invalid Contact Number"));
            }
            return Promise.resolve();
          },
        },
      ]}
      label={label}
    >
      <PhoneInput
        defaultCountry="IN"
        onChange={(val) => {
          form.setFieldValue(name, val);
        }}
        placeholder={placeholder || "Enter phone number"}
        limitMaxLength
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default ContactInput;
